module.exports = __webpack_public_path__ + "img/145.9.45a25da3.png";